<template>
  <div class="sys-class">

    <div class="main">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="行政班" name="first">
          <header class="header">
            <el-form>
              <el-select v-model="gradeId" placeholder="选择年级" size="small">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id">
                </el-option>
              </el-select>
              <el-button v-if="$store.getters.isXkwAdmin" type="primary" size="small" @click="jumpNext">新增</el-button>
              <el-button v-if="$store.getters.isXkwAdmin" size="small" @click="jumpNext">修改</el-button>
            </el-form>
          </header>
          <div class="table-wrap" style="padding: 10px;background: #fff;">
            <el-table class="class-table" :data="tableData" border v-loading="loading" size="medium"  :row-class-name="tableRowClassName">
              <el-table-column prop="className" label="班级" v-if="subjectList.length">
              </el-table-column>
              <el-table-column v-for="sub in subjectList" :key="sub.id" :label="sub.shortName">
                <template slot-scope="scope">
                 {{scope.row[sub.shortName]}}
                </template>

              </el-table-column>
              <el-table-column prop="classTea" label="班主任" v-if="subjectList.length">
                <template slot-scope="scope">
                  {{scope.row.classTea}}
                </template>
              </el-table-column>
              <el-table-column prop="studNum" label="班级人数" v-if="subjectList.length">
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="teachingGradeList.length > 0" label="教学班" name="second">
          <header class="header">
            <el-form>
              <el-select v-model="gradeId2" placeholder="选择年级" size="small">
                <el-option v-for="item in teachingGradeList" :key="item.id" :label="item.gradeName" :value="item.id">
                </el-option>
              </el-select>
              <el-button v-if="$store.getters.isXkwAdmin" type="primary" size="small" @click="jumpNext">新增</el-button>
            </el-form>
          </header>
          <div class="table-wrap" style="padding: 10px;background: #fff;">
            <el-table :v-loading="loading" :key="Math.random()" class="class-table" :data="teachingTableData" border v-loading="loading" size="medium" :row-class-name="tableRowClassName" @cell-mouse-enter="handleMouseEnter2" @cell-mouse-leave="handleMouseLeave2">
              <el-table-column v-for="sub in teachingClassList" min-width="130px" prop="t" :key="sub.courseId" :label="sub.courseName">
                <template slot-scope="scope">
                  <div class="teacher-item" :key="i" v-if="sub.teachClasses" v-for="(t,i) in sub.teachClasses">
                    <div style="text-align:left">
                      <span>{{t.className}}</span>
                    </div>
                    <div style="text-align:left">
                      <span>{{t.teacherName}}</span>
                      <span style="margin-left:10px" :title="t.studNum + '个学生'">{{t.studNum}}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { queryListGrade, configApi, getTeacher } from '@/api/api'
import { queryClassInfo, addClassInfo, getSchoolTeacherListBySubject, deleteTeachClass, getTeachClassList2, getTerm } from '@/v3/modules/base_data/utils/system'

import {
  mapGetters
} from 'vuex'
import BasePage from '../BasePage.vue'
export default {
  extends: BasePage,
  data () {
    return {
      roleList: [],
      schoolTeacherList: [],
      teachingGradeList: [],
      gradeName: '',
      teachingTableData: [],
      teachingClassList: [],
      year: '',
      termId: '',
      teacherList: [],
      dialogTeachingClassVisible: false,
      classType: 1,
      teachingClassType: 1,
      addClassForm: {
        className: '',
        classTeacherIds: ''
      },
      addTeachingClassForm: {
        gradeId: '',
        className: '',
        subjectCode: '',
        teacherId: ''
      },
      activeName: 'first',
      //学校信息
      schoolId: '',
      schoolCode: '',
      schoolName: '',

      //返回结果放入对应的变量
      classList: [],
      //修改任课教师后的数据
      sendData: {},
      teacherName: '',

      searchTeacherId: '',
      searchInputVisible: false,
      searchInputVisible2: false,
      loading: false,
      searching: false,
      result: [],
      gradeId: '',
      gradeId2: '',
      gradeList: [],
      subjectList: [],
      tableData: [],
      tableData2: [],
      tableRowClassName ({
        row,
        rowIndex
      }) {
        if (rowIndex % 2 === 1) {
          return 'stripe';
        }
      },
      rules: {
        className: [{
          required: true,
          message: '请输入班级名称',
          trigger: 'blur'
        }],
        gradeId: [{
          required: true,
          message: '请选择年级',
          trigger: 'change'
        }],
        subjectCode: [{
          required: true,
          message: '请选择学科',
          trigger: 'change'
        }],
      }
    }
  },
  watch: {
    gradeId (val) {
      this.postQueryClassInfo()
    },
    gradeId2 (val) {
      if (val) {
        this.getTeachClassList()
      }
    }
  },

  methods: {
    async getSchoolTeacherList () {
      let res = await getTeacher({
        schoolId: this.userInfo.schoolId
      })
      if (res.body) {
        this.schoolTeacherList = res.body
      } else {
        this.$message.error(res.message)
      }
    },
    handleTeachingClosed () {
      this.addTeachingClassForm = {
        gradeId: '',
        className: '',
        subjectCode: '',
        teacherId: ''
      }
    },
    handleClosed () {
      this.addClassForm = {
        className: '',
        classTeacherIds: ''
      }
    },
    handleTabClick () {
      if (this.activeName == 'first') {
        this.postQueryClassInfo()
      } else {
        this.getTeachClassList()
      }
    },
    //获取教学班级列表
    async getTeachClassList () {
      if (!this.gradeId2) {
        return this.$message.error('请选择年级')
      }
      this.loading = true
      let res = await getTeachClassList2({
        schoolId: this.userInfo.schoolId,
        gradeId: this.gradeId2,
        startYear: this.userInfo.academicYear,
        term: this.termId
      })
      this.loading = false
      if (res.body) {
        let ifData = res.body.some(r => r.teachClasses)
        if (ifData) {
          this.teachingTableData = [{
            t: +new Date()
          }]
        } else {
          this.teachingTableData = []
        }
        this.teachingClassList = res.body
      } else {
        this.$message.error(res.message)
      }
    },
    //删除教学班级
    deleteTeachClass () {
      this.$confirm('确认删除该教学班？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await deleteTeachClass({
          teachClassId: this.addTeachingClassForm.id
        })
        if (res.code == 200) {
          this.addTeachingClassForm = {
            gradeId: '',
            className: '',
            subjectCode: '',
            teacherId: ''
          }
          this.$message.success('删除成功')
          this.dialogTeachingClassVisible = false
          this.teachingClassType = 1
          this.handleTabClick()
        } else {
          this.$message.error(res.message)
        }
      });
    },
    handleMouseEnter (row, column, cell, event) {
      let cIndex = 0;
      this.subjectList.map((s, i) => {
        if (s.short == column.label) {
          cIndex = i + 1
        }
      })
      if (cIndex || column.label == "班主任") {
        this.searchInputVisible2 = row.id + column.label
        if (this.searchInputVisible !== row.id + column.label) {
          row.hoverVisible = true
          cell.style.background = '#5b5b5b'
        }
      }
    },
    handleMouseLeave (row, column, cell, event) {

      this.searchInputVisible2 = ''
      row.hoverVisible = false
      cell.style.background = 'transparent'
    },
    handleMouseEnter2 (row, column, cell, event) {
      cell.style.background = '#f5f7fa'
    },
    handleMouseLeave2 (row, column, cell, event) {
      cell.style.background = 'white'
    },
    //根据学科获取老师
    async _getTeacher (subjectCode) {
      let params = {
        schoolId: this.userInfo.schoolId,
        subjectCode: subjectCode
      }
      let resp = await getSchoolTeacherListBySubject(params)
      if (resp.code = 200 && resp.result) {
        this.teacherList = resp.result
      } else {
        this.loading = false
        return
      }

    },
    //设置学校信息
    setSchoolInfo () {
      if (this.userInfo) {
        this.schoolId = this.userInfo.schoolId
        this.schoolName = this.userInfo.schoolName
        this.schoolCode = this.userInfo.schoolCode
      }
    },

    //获取年级列表
    async postQueryGrade (schoolId) {
      let response = await queryListGrade({ schoolId })
      if (response.body) {
        this.gradeList = response.body
        this.gradeId = this.gradeList.length > 0 ? this.gradeList[0].id : ''
        this.initTeachingClassGradeList()
      }
    },

    //查询班级详细信息
    async postQueryClassInfo () {
      if (!this.gradeId) return
      this.loading = true
      let response = await queryClassInfo({
        schoolId: this.schoolId,
        gradeId: this.gradeId
      })
      this.loading = false
      if (response.body) {
        let data = response.body
        let cls = data.gradeClass //班级列表对象
        let subjectTea = data.subjectTea //各班各课老师
        // let studentCount = data.studentCount //班级人数
        let classTea = data.classTea //班主任
        let classRole = data.classRole //班主任角色信息
        let subjectRole = data.subjectRole //任课老师角色信息

        this.subjectList = []
        this.tableData = []
        for (let key in data.subject) { //学科信息
          this.subjectList.push(data.subject[key])
        }

        try {
          for (let key of data.className) {
            let item = cls[key]

            let subjectTeaObj = subjectTea[key]
            for (let i in subjectTeaObj) {
              let subArr = subjectTeaObj[i]

              item[i] = ''
              if (subArr.length > 0) {
                for (let sub of subArr) {
                  item[i] += sub.nickName + ' ' //任课教师姓名拼接
                }
              }

            }
            item['subjectTeaObj'] = subjectTeaObj
            //班级人数
            // item.studentCount = studentCount[key]

            //添加班主任、任课老师角色信息
            item.classRole = classRole
            item.subjectRole = subjectRole

            //拼接班主任姓名
            let classTeaName = ''
            let classTeaId = ''
            if (classTea.hasOwnProperty(key)) {
              for (let item of classTea[key]) {
                classTeaName += item.nickName + ' '
                classTeaId = item.id
              }
            }
            item.classTea = classTeaName
            item.classTeaId = classTeaId
            item.hoverVisible = false
            item['subjectObj'] = data.subject
            this.tableData.push(item)
          }
        } catch (e) {

        }
      }
    },

    //更改某科目任课老师
    async postAddClassInfo (data, row, column) {
      let response = await addClassInfo(data)
      if (response.code === 200) {
        if (column.label == '班主任') {
          row.classTea = this.teacherName
        } else {
          row[column.label] = this.teacherName
        }

        this.searchInputVisible = false
        this.$message({
          type: 'success',
          message: '修改成功！'
        })
        this.postQueryClassInfo()
      } else {
        this.$message.error(`操作失败！${response.message}`)
      }

    },

    handleSearchTeacher (row, column, cell) {
      row.hoverVisible = false
      cell.style.background = 'transparent'
      this.searchInputVisible2 = false
      this.searchTeacherId = row.classTeaId || '' //
      this.result = []
      this.searchInputVisible = row.id + column.label
      this.searchSubjectInfo(column.label)
    },
    searchSubjectInfo (name) {
      Object.keys(this.subjectList).forEach(key => {
        let item = this.subjectList[key]
        if (item.shortName == name) {
          this.sendData.subjectId = item.id
          this.sendData.subjectName = item.shortName
          this.sendData.subjectCode = item.id
        }
      })
    },
    loseFocus () {
      this.sendData = {}
      this.searchInputVisible = ''
    },
    async initYearAndTerm () {
      const resp = await getTerm(this.userInfo.schoolId)
      this.year = resp.body.year;
      this.termId = resp.body.term;
    },
    //生成有走班权限的年级
    async initTeachingClassGradeList () {
      let response = await configApi.getConfigByTypes(this.userInfo.schoolId, ['EXAM_OTHER_TEACH_CLASS'])
      if (response.body) {
        if (response.body.length) {
          const gradeNums = response.body[0].configValue.split(',').map(g => parseInt(g))
          this.teachingGradeList = this.gradeList.filter(g => gradeNums.indexOf(g.gradeNum) > -1)
          if (this.teachingGradeList.length > 0) {
            this.gradeId2 = this.teachingGradeList[0].id
          }
        }
      }
    }
  }, //methods end

  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    })
  },

  mounted () {
    this.setSchoolInfo()
    this.initYearAndTerm()
    this.postQueryGrade(this.schoolId)
  }
}

</script>
<style lang="scss">
.sys-class {
  /*min-height: calc(100vh - 186px);*/
  /*border: 1px solid #979797;*/
  margin: 14px 0;
  background-color: #fff;
  border-radius: 4px;

  .header {
    background-color: #fff;
    /*margin-top: 14px;*/
    padding: 0px 20px;

    .el-select {
      margin-right: 16px;
      width: 130px;
    }
  }

  .main {
    padding: 10px 30px;

    /*min-height: calc(100vh - 170px - 74px);*/
    .el-table td,
    .el-table th.is-leaf {
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.hover_show {
  color: white;
  cursor: pointer;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: white;
}
.cell {
  .teacher-item {
    border-bottom: 1px dotted #cccccc;
    .item-icon {
      visibility: hidden;
    }
  }
  .teacher-item:last-child {
    border-bottom: none;
  }
  .teacher-item {
    &:hover {
      .item-icon {
        visibility: visible;
      }
    }
  }
}
::v-deep.search-input .el-input__inner {
  padding-left: 2px;
  padding-right: 2px;
}
</style>
